import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
import SelectDropDown from '../selectdropdown/SelectDropDown'
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';
import moment from "moment";
import './_feeStructure.scss';

import FeeDashBoardSection from './feeDashBoard/feeDashBoardSection';
import FeeSetupSection from './FeeSetup/feeSetupSection';
import StudentPayments from './studentPayments/studentPaymentsSection'

const FETCH_GLOBALS = gql`
  query($institution_id: Int!) {
    globals(institution_id: $institution_id) {
      b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      globalPackages {
        id
        package_name
        exams_covered
      }
      globalCategories {
        id
        category_name
        package_id
      }
      classes {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
        branch_id
        category_id
        package_id
      }
      offlineExamSubjects{
        id
        subject
      }
      offlineFeeTypes{
        id
        fee_type
      }
    }
  }
`;

const FETCH_STUDENTS = gql`
  query($institution_id: Int!) {
    getStudents(institution_id: $institution_id) {
      id
      student_name
      contact_no
      branch_id
      class_id
      section_id
      package_id
      category_id
      exam_id
    }
  }
`;

const FETCH_PAYMENT_MODES = gql`
  query($id: Int) {
    getPaymentModes(id: $id) {
     id
     payment_mode
    }
  }
`;

const GET_STUDENT_PAYMENTS = gql`
query($institute_id: Int){
  getStudentPaymentDetails(institute_id: $institute_id) {
    roll_no
    student_name
    class_name
    section_name
    branch_name
    exam_name
    exam_id
    section_id
    class_id
    branch_id
    total_amount
    pending_amount
    student_mobile
    paid_amount
    tutionFee
    individualDetails{
      discount
      fee_type_id
      fee_amount
      discount
      total_fee
    }
    term_details {
      no_of_terms
      fee_type_id
      initial_amount
      total_amount
      terms {
        term_no
        term_date
        term_amount
        is_paid
        comments
        payment_mode_id
        paid_date
        payment_id
      }
    }
  }
}
`

class FeeStructureHome extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blockType: "FeeSetup"
    }
  }

  handleSelect(val) {
    this.setState({
      blockType: val
    })
  }

  render() {

    console.log("state", this.state);

    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getStudents = this.props.getStudents;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;

    const getStudentPaymentDetails = this.props.getStudentPaymentDetails;
    const loading = getStudentPaymentDetails.loading
    const error = getStudentPaymentDetails.error


    const getPaymentModes = this.props.getPaymentModes;
    const loading3 = getPaymentModes.loading;
    const error3 = getPaymentModes.error;

    if (loading1 || loading2 || loading || loading3) return null;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    if (error !== undefined) {
      alert("Server Error. " + error.message);
      return null;
    }
    if (error3 !== undefined) {
      alert("Server Error. " + error.message);
      return null;
    }


    return (
      <Container fluid className="feeStructure">
        <Row>
          <Col sm={4} className='mt-3 mb-3'>
            <Card className={this.state.blockType == "FeeSetup" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("FeeSetup")}>
              <Card.Body>
                <h5 className="text-center color_blue"><img className="mr-2" src={require('../../../images/create_quiz_blue.png')} alt="Create_Quiz" /> <span className='title_alignment'>Fee Setup</span></h5>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={4} className='mt-3 mb-3'>
            <Card className={this.state.blockType == "studentPayments" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("studentPayments")}>
              <Card.Body>
                <h5 className="text-center color_blue"><img className="mr-2" src={require('../../../images/manage_quiz_blue.png')} alt="Manage_Quiz" /> <span className='title_alignment'>Student Payments</span></h5>
              </Card.Body>
            </Card>

          </Col>
          <Col sm={4} className='mt-3 mb-3'>
            <Card className={this.state.blockType == "feeDashBoard" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("feeDashBoard")}>
              <Card.Body>
                <h5 className="text-center color_blue"><img className="mr-2" src={require('../../../images/quiz_summary_blue.png')} alt="Quiz_summary" /> <span className='title_alignment'>Fee Dashboard</span></h5>
              </Card.Body>
            </Card>
          </Col>
          {/* {
            this.state.blockType == "FeeSetup" ? <FeeSetupSection globals={globals.globals} /> : 
              this.state.blockType == "studentPayments" ? <StudentPayments globals={globals.globals} getStudents={getStudents.getStudents} getStudentPaymentDetails={getStudentPaymentDetails.getStudentPaymentDetails} getPaymentModes={getPaymentModes.getPaymentModes} /> :
                this.state.blockType == "feeDashBoard" ? <FeeDashBoardSection globals={globals.globals} /> : ""
          } */}




          {
            (() => {
              let globalsData = globals.globals;
              if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                let globalBranches = [];

                globalsData.globalBranches.map((item) => {
                  if (Cookies.get("branch_id") == item.id) {
                    globalBranches.push(item)
                  }
                });

                globalsData.globalBranches = globalBranches
              }

              return (
                <>
                  {
                    this.state.blockType == "FeeSetup" ? <FeeSetupSection globals={globalsData} /> :
                      this.state.blockType == "studentPayments" ? <StudentPayments globals={globalsData} getStudents={getStudents.getStudents} getStudentPaymentDetails={getStudentPaymentDetails.getStudentPaymentDetails} getPaymentModes={getPaymentModes.getPaymentModes} /> :
                        this.state.blockType == "feeDashBoard" ? <FeeDashBoardSection globals={globalsData} /> : ""
                  }

                </>
              );
            })()
          }
        </Row>
      </Container>
    )
  }
}

export default withRouter(withApollo(compose(
  graphql(FETCH_GLOBALS, {
    options: (props) => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
    }),
    name: "globals",
  }),
  graphql(GET_STUDENT_PAYMENTS, {
    options: (props) => ({
      variables: {
        institute_id: parseInt(Cookies.get("institutionid")),
      },
      fetchPolicy: "cache-and-network",
    }),
    name: "getStudentPaymentDetails",
  }),
  graphql(FETCH_STUDENTS, {
    options: (props) => ({
      variables: {
        institution_id: parseInt(Cookies.get("institutionid")),
      },
      fetchPolicy: "cache-and-network",
    }),
    name: "getStudents",
  }),
  graphql(FETCH_PAYMENT_MODES, {
    options: (props) => ({
      variables: {
        id: parseInt(0),
      },
      fetchPolicy: "cache-and-network",
    }),
    name: "getPaymentModes",
  }),
)(FeeStructureHome))
);